(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    window.AccordionComponent = function (activeByDefault) {
    return {
      active: activeByDefault,
      disabled: false,
      childrenHeight: `0px`,
      resizeObserver: null,
      init: function () {
        this.resizeObserver = new ResizeObserver(this.calculateChildrenHeight.bind(this));
        this.resizeObserver.observe(this.$refs.children);
      },
      destroy: function () {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
      },
      onClick: function () {
        this.calculateChildrenHeight();
        this.active = !this.active;
      },
      get arrowDirection() {
        return this.active ? 'down' : 'right';
      },
      calculateChildrenHeight: function () {
        const childrenHeight = this.$refs.children.getBoundingClientRect().height;
        this.childrenHeight = childrenHeight + 'px';
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-communication-settings"] && !Shopify.designMode) return;
  try {
    window.AccountCommunicationSettingsComponent = function (
    klaviyoListIdForEmailSubscription,
    klaviyoListIdForSmsSubscription,
    textPhoneNumberRequiredErrorMessage,
    customerEmail,
    originalEmailConsent
  ) {
    return {
      isCustomerDataPending: false,
      isCustomerDataSuccess: false,
      isCustomerDataError: false,
      isPending: false,
      isSuccess: false,
      isError: false,
      errorMessage: '',
      mutation: null,
      init: function () {
        window.query({
          key: 'account-communication-settings',
          fn: () => {
            return this.getCustomerData();
          },
          subscribeFn: (result) => {
            this.isCustomerDataPending = result.isPending;
            this.isCustomerDataSuccess = result.isSuccess;
            this.isCustomerDataError = result.isError;
            this.customerDataErrorMessage = result.error;
            if (result.isSuccess) {
              this.textConsent = result.data.canReceiveSmsMarketing;
              this.originalTextConsent = result.data.canReceiveSmsMarketing;
              this.textPhoneNumber = result.data.phoneNumber;
              this.originalTextPhoneNumber = result.data.phoneNumber;
              if (result.data.properties?.interests) {
                this.interests = result.data.properties.interests;
              }
              if (result.data.properties?.membersNewsConsent) {
                this.membersNewsConsent = result.data.properties.membersNewsConsent;
              }
            }
          },
        });

        this.mutation = window.createMutation({
          mutationFn: () => this._saveChanges(),
          subscribeFn: (result) => {
            this.isPending = result.isPending;
            this.isSuccess = result.isSuccess;
            this.isError = result.isError;
            this.errorMessage = result.error;
            if (result.isSuccess) {
              this.originalEmailConsent = this.emailConsent;
              this.originalTextConsent = this.textConsent;
              this.originalTextPhoneNumber = this.textPhoneNumber;
            }
          },
        });
      },
      _saveChanges: function () {
        if ((this.isTextConsentChanged || this.isTextPhoneNumberChanged) && this.textConsent && !this.textPhoneNumber) {
          throw new Error(textPhoneNumberRequiredErrorMessage);
        }

        const textAction =
          this.isTextConsentChanged || this.isTextPhoneNumberChanged
            ? this.textConsent
              ? 'subscribe'
              : 'unsubscribe'
            : 'none';
        const emailAction = this.isEmailConsentChanged ? (this.emailConsent ? 'subscribe' : 'unsubscribe') : 'none';

        const properties = { interests: this.interests, membersNewsConsent: this.membersNewsConsent };
        if (textAction === 'subscribe' && emailAction === 'subscribe') {
          return Promise.all([
            this.subscribeToList({
              email: customerEmail,
              subscriptionType: 'email',
              phoneNumber: this.textPhoneNumber,
              properties,
              listId: klaviyoListIdForEmailSubscription,
            }),
            this.subscribeToList({
              email: customerEmail,
              subscriptionType: 'sms',
              phoneNumber: this.textPhoneNumber,
              properties,
              listId: klaviyoListIdForSmsSubscription,
            }),
          ]);
        } else if (textAction === 'unsubscribe' && emailAction === 'unsubscribe') {
          return Promise.all([
            this.unsubscribe({ subscriptionType: 'both' }),
            this.updateProfile({ email: customerEmail, properties }),
          ]);
        } else if (textAction === 'subscribe' && emailAction === 'unsubscribe') {
          return Promise.all([
            this.subscribeToList({
              email: customerEmail,
              subscriptionType: 'sms',
              phoneNumber: this.textPhoneNumber,
              properties,
              listId: klaviyoListIdForSmsSubscription,
            }),
            this.unsubscribe({ subscriptionType: 'email' }),
          ]);
        } else if (textAction === 'unsubscribe' && emailAction === 'subscribe') {
          return Promise.all([
            this.unsubscribe({ subscriptionType: 'sms' }),
            this.subscribeToList({
              email: customerEmail,
              subscriptionType: 'email',
              properties,
              listId: klaviyoListIdForEmailSubscription,
            }),
          ]);
        } else if (textAction === 'subscribe' && emailAction === 'none') {
          return this.subscribeToList({
            email: customerEmail,
            subscriptionType: 'sms',
            phoneNumber: this.textPhoneNumber,
            properties,
            listId: klaviyoListIdForSmsSubscription,
          });
        } else if (textAction === 'none' && emailAction === 'subscribe') {
          return this.subscribeToList({
            email: customerEmail,
            subscriptionType: 'email',
            properties,
            listId: klaviyoListIdForEmailSubscription,
          });
        } else if (textAction === 'none' && emailAction === 'unsubscribe') {
          return Promise.all([
            this.unsubscribe({ subscriptionType: 'email' }),
            this.updateProfile({ email: customerEmail, properties }),
          ]);
        } else if (textAction === 'unsubscribe' && emailAction === 'none') {
          return Promise.all([
            this.unsubscribe({ subscriptionType: 'sms' }),
            this.updateProfile({ email: customerEmail, properties }),
          ]);
        }

        return this.updateProfile({ email: customerEmail, properties });
      },
      saveChanges: function () {
        this.mutation.mutate();
      },
      originalEmailConsent: originalEmailConsent,
      emailConsent: originalEmailConsent,
      onEmailConsentChange: function () {
        this.emailConsent = !this.emailConsent;
      },
      get isEmailConsentChanged() {
        return this.emailConsent !== this.originalEmailConsent;
      },
      originalTextConsent: false,
      textConsent: false,
      onTextConsentChange: function () {
        this.textConsent = !this.textConsent;
      },
      get isTextConsentChanged() {
        return this.textConsent !== this.originalTextConsent;
      },
      originalTextPhoneNumber: '',
      textPhoneNumber: '',
      get isTextPhoneNumberChanged() {
        return this.textPhoneNumber !== this.originalTextPhoneNumber;
      },
      membersNewsConsent: false,
      onMembersNewsConsentChange: function () {
        this.membersNewsConsent = !this.membersNewsConsent;
      },
      interests: [],
      onInterestChange: function (interest) {
        if (this.interests.includes(interest)) {
          this.interests = this.interests.filter((i) => i !== interest);
        } else {
          this.interests.push(interest);
        }
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-personal-information"] && !Shopify.designMode) return;
  try {
    window.AccountPersonalInformationComponent = function (email, firstName, lastName, dateOfBirth) {
    return {
      originalEmail: email,
      email: email,
      password: '',
      firstName: firstName,
      lastName: lastName,
      dateOfBirth: dateOfBirth,
      _showEmailInput: false,
      _showPasswordInput: false,
      validator: null,
      isSuccess: false,
      isPending: false,
      errorMessage: '',
      init() {
        this.validator = new JustValidate(this.$root, {
          errorLabelStyle: {
            display: 'none',
          },
        });

        this.validator.onFail((errors) => {
          this.errorMessage = Object.values(errors)
            .map((error) => error.errorMessage)
            .join(', ');
          this.isSuccess = false;
        });

        this.updateCustomerMutation = window.createMutation({
          mutationFn: () => this.updateCustomer(),
          subscribeFn: (result) => {
            this.isPending = result.isPending;
            this.isSuccess = result.isSuccess;
            this.errorMessage = result.error;

            if (result.isSuccess) {
              if (this.email !== this.originalEmail) {
                window.location.reload(true);
              }
            }
          },
        });
      },
      saveChanges: function () {
        this.errorMessage = '';
        this.isSuccess = false;
        this.validator.revalidate().then((isValid) => {
          if (isValid) {
            this.updateCustomerMutation.mutate();
          }
        });
      },
      updateCustomer: async function () {
        if (this.showEmailInput) {
          CF.customer.set('email', this.email);
        }
        if (this.firstName) {
          CF.customer.set('first_name', this.firstName);
        }
        if (this.lastName) {
          CF.customer.set('last_name', this.lastName);
        }
        if (this.dateOfBirth) {
          CF.customer.set('birthday', this.dateOfBirth);
        }
        try {
          const errorObj = await CF.customer.save();
          if (errorObj) {
            throw new Error(
              Object.entries(errorObj)
                .map(([key, value]) => `${key}: ${value}`)
                .join(', ')
            );
          } else {
            return 'success';
          }
        } catch (err) {
          throw err;
        }
      },
      get showEmailInput() {
        return this._showEmailInput;
      },
      set showEmailInput(value) {
        this._showEmailInput = value;
        if (value) {
          this.$nextTick(() => {
            this.validator.addField('#email', [
              {
                rule: 'required',
                errorMessage: 'Email is required',
              },
              {
                rule: 'email',
                errorMessage: 'Invalid email',
              },
            ]);
          });
        }
      },
      get showPasswordInput() {
        return this._showPasswordInput;
      },
      set showPasswordInput(value) {
        this._showPasswordInput = value;
        if (value) {
          this.$nextTick(() => {
            this.validator.addField('#password', [
              {
                rule: 'required',
                errorMessage: 'Password is required',
              },
            ]);
          });
        }
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-tabs"] && !Shopify.designMode) return;
  try {
    window.AccountTabsComponent = function () {
    return {
      init() {
        // mobile menu
        if (this.$refs.mobileMenu)
          new Swiper(this.$refs.mobileMenu, {
            slidesPerView: 'auto',
            freeMode: true,
            mousewheel: {
              forceToAxis: true,
            },
          });
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["arrow-icon"] && !Shopify.designMode) return;
  try {
    window.ArrowIconComponent = function (direction) {
    return {
      direction: direction,
      enableTransition: true,
      classes: {
        down: {
          arrow_class: 'rotate-90',
          second_arrow_bg_class: 'left-0 bottom-full group-hover/arrow-icon:translate-y-full',
          second_arrow_class:
            'left-1/2 -translate-x-1/2 bottom-full group-hover/arrow-icon:translate-y-[calc(-25%+1rem)]',
          first_arrow_container_class: 'group-hover/arrow-icon:translate-y-full',
        },
        up: {
          arrow_class: 'rotate-270',
          second_arrow_bg_class: 'left-0 top-full group-hover/arrow-icon:-translate-y-full',
          second_arrow_class: 'left-1/2 -translate-x-1/2 top-full group-hover/arrow-icon:translate-y-[calc(25%-1rem)]',
          first_arrow_container_class: 'group-hover/arrow-icon:-translate-y-full',
        },
        left: {
          arrow_class: 'rotate-180',
          second_arrow_bg_class: 'left-full top-0 group-hover/arrow-icon:-translate-x-full',
          second_arrow_class:
            'left-full top-1/2 -translate-y-1/2 group-hover/arrow-icon:translate-x-[calc(25%-1.375rem)]',
          first_arrow_container_class: 'group-hover/arrow-icon:-translate-x-full',
        },
        right: {
          arrow_class: 'rotate-0',
          second_arrow_bg_class: 'right-full top-0 group-hover/arrow-icon:translate-x-full',
          second_arrow_class:
            'right-full top-1/2 -translate-y-1/2 group-hover/arrow-icon:translate-x-[calc(-25%+1.375rem)]',
          first_arrow_container_class: 'group-hover/arrow-icon:translate-x-full',
        },
      },
      init: function () {
        this.$watch('direction', (value) => {
          this.enableTransition = false;
          setTimeout(() => {
            this.enableTransition = true;
          }, 200);
        });
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["breakpoints-store"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.store('breakpoints', {
      isMobile: false,
      isTablet: false,
      init() {
        const onResize = () => {
          this.isMobile = window.innerWidth < 640;
          this.isTablet = window.innerWidth >= 640 && window.innerWidth < 1024;
        };

        onResize();
        window.addEventListener('resize', onResize);
      },
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-api"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.store('cartApi', {
      init() {},
      getCart: async function () {
        const response = await fetch(window.Shopify.routes.root + 'cart.js', {
          method: 'GET',
          cache: 'no-store',
        });
        if (!response.ok) {
          throw new Error('Failed to get cart');
        }
        const data = await response.json();
        return data;
      },
      addToCart: async function ({ items, sections }) {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(`Failed to add to cart: ${error?.message}`);
        }

        const data = await response.json();
        return data;
      },
      updateCart: async function ({ updates, discount }) {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates, discount }),
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(`Failed to add to cart: ${error?.message}`);
        }

        const data = await response.json();
        return data;
      },
      generateShippingRates: async function ({ country, zip, province }) {
        const response = await fetch(
          `${window.Shopify.routes.root}cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (!response.ok) {
          const errors = await response.json();
          throw new Error(`Failed to get shipping rates: ${Object.values(errors).join(', ')}`);
        }

        const response2 = await fetch(
          `${window.Shopify.routes.root}cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`
        );

        if (!response2.ok) {
          const errors = await response2.json();
          throw new Error(`Failed to get shipping rates: ${Object.values(errors).join(', ')}`);
        }

        const data = await response2.json();
        return data;
      },
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-store"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.store('cart', {
      isCartPanelOpen: false,
      queryClient: null,
      data: Alpine.$persist(null).as('cartData'),
      isPending: false,
      isSuccess: false,
      isError: false,
      errorMessage: null,
      updateCartMutation: null,
      addToCartMutation: null,
      alignPersonalizationProductQuantityMutation: null,
      init() {
        this.queryClient = window.query({
          key: 'cart',
          fn: () => Alpine.store('cartApi').getCart(),
          subscribeFn: (result) => {
            this.isPending = result.isPending;
            this.isSuccess = result.isSuccess;
            this.isError = result.isError;
            this.errorMessage = result.error;
            if (result.isSuccess) {
              this.data = result.data;
              Alpine.nextTick(() => {
                this.alignPersonalizationProductQuantity();
              });
            }
          },
        });

        this.updateCartMutation = window.createMutation({
          mutationFn: (data) => {
            if (data.updates) {
              const personalizationProductId = Alpine.store('settings').personalizationProductId;
              const personalizationProductQuantity =
                this.data?.items?.find((item) => item.id === personalizationProductId)?.quantity ?? 0;

              const lineItemsExcludingPersonalizationProduct = this.data?.items?.filter(
                (item) => item.id !== personalizationProductId
              );

              const personalizedLineItemsQuantity =
                this.data?.items
                  ?.filter((item) => item.id !== personalizationProductId && !!item.properties.personalization)
                  .reduce(
                    (acc, item) =>
                      item.key in data.updates
                        ? acc + data.updates[item.key] * item.properties._personalizationPrice
                        : acc + item.quantity * item.properties._personalizationPrice,
                    0
                  ) ?? 0;

              if (personalizationProductQuantity !== personalizedLineItemsQuantity) {
                data.updates[personalizationProductId] = personalizedLineItemsQuantity;
              }
            }
            return Alpine.store('cartApi').updateCart(data);
          },
          scope: {
            id: 'cart-update',
          },
          onSuccess: () => {
            Alpine.nextTick(() => {
              this.alignPersonalizationProductQuantity();
            });
          },
        });

        this.addToCartMutation = window.createMutation({
          mutationFn: (data) => Alpine.store('cartApi').addToCart(data),
          scope: {
            id: 'cart-update',
          },
          onSuccess: () => {
            Alpine.nextTick(() => {
              this.alignPersonalizationProductQuantity();
            });
          },
        });

        this.alignPersonalizationProductQuantityMutation = window.createMutation({
          mutationFn: (data) => Alpine.store('cartApi').updateCart(data),
          scope: {
            id: 'cart-update',
          },
        });
      },
      formatPrice(price) {
        if (!this.data) {
          return null;
        }
        return new Intl.NumberFormat(`${window.Shopify.locale}-${window.Shopify.country}`, {
          style: 'currency',
          currency: this.data.currency,
          trailingZeroDisplay: 'stripIfInteger',
        }).format(price * 0.01);
      },
      getItemCount: function () {
        const personalizationProductId = Alpine.store('settings').personalizationProductId;
        const lineItemsExcludingPersonalizationProduct = this.data?.items?.filter(
          (item) => item.id !== personalizationProductId
        );
        return lineItemsExcludingPersonalizationProduct?.reduce((acc, item) => acc + item.quantity, 0);
      },
      // Returns the personalization surcharge (in cents, in the cart's active currency)
      // attributable to a single unit of the given parent line item. Returns 0 when the
      // line item has no personalization or the hidden personalization line is absent.
      getPersonalizationSurchargePerUnitInCents: function (line_item) {
        const priceMultiplier = parseInt(line_item?.properties?._personalizationPrice);
        if (!priceMultiplier) return 0;
        const personalizationProductId = Alpine.store('settings').personalizationProductId;
        const personalizationLine = this.data?.items?.find((i) => i.id === personalizationProductId);
        if (!personalizationLine) return 0;
        return personalizationLine.price * priceMultiplier;
      },
      openCartPanel: function () {
        this.isCartPanelOpen = true;
      },
      closeCartPanel: function () {
        this.isCartPanelOpen = false;
      },
      alignPersonalizationProductQuantity: function () {
        const personalizationProductId = Alpine.store('settings').personalizationProductId;
        const personalizationProductQuantity =
          this.data?.items?.find((item) => item.id === personalizationProductId)?.quantity ?? 0;

        const personalizedLineItemsQuantity =
          this.data?.items
            ?.filter((item) => item.id !== personalizationProductId && !!item.properties.personalization)
            .reduce((acc, item) => acc + item.quantity * item.properties._personalizationPrice, 0) ?? 0;
        if (personalizationProductQuantity !== personalizedLineItemsQuantity) {
          this.alignPersonalizationProductQuantityMutation.mutate({
            updates: {
              [personalizationProductId]: personalizedLineItemsQuantity,
            },
          });
          return;
        }
      },
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["compare-panel-layout"] && !Shopify.designMode) return;
  try {
    window.ComparePanelLayoutComponent = function () {
    return {
      index: null,
      init() {
        const index = parseInt(this.$root.dataset.index);
        if (Number.isNaN(index)) return;
        this.index = index;
      },
      get isPanelOpen() {
        return this.$store.comparePanel.isComparePanelOpen && this.$store.comparePanel.step === this.index;
      },
      set isPanelOpen(value) {
        this.$store.comparePanel.isComparePanelOpen = value;
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["compare-panel-store"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    return Alpine.store('comparePanel', {
      isComparePanelOpen: false,
      step: 0,
      compareProducts: [],
      selectedProductIndex: null,
      productHtmls: [],
      isPending: false,
      disableChangeFirstProduct: false,
      addCompareProduct(productId, productHandle) {
        const index = this.productHtmls[0] ? 1 : 0;
        this.compareProducts[index] = { id: productId, handle: productHandle };
        this.step++;
        window.query({
          key: ['productHtmls', productHandle],
          fn: () => this.getProductColumn(productHandle),
          subscribeFn: (result, unsubscribe) => {
            this.isPending = result.isPending;
            if (result.isSuccess) {
              this.productHtmls[index] = result.data;
              unsubscribe?.();
            }
          },
        });
      },
      removeCompareProduct(productId) {
        const index = this.compareProducts.findIndex((p) => p && p?.id === productId);
        this.compareProducts[index] = undefined;
        this.productHtmls[index] = undefined;
        this.step--;
      },
      isCompareProduct(productId) {
        return this.compareProducts.some((p) => p.id === productId);
      },
      setSelectedProductIndex(productIndex) {
        this.selectedProductIndex = productIndex;
        this.step = 3;
      },
      async getProductColumn(productHandle) {
        const response = await fetch(
          `${window.Shopify.routes.root}products/${productHandle}?sections=compare-panel-columns`
        );
        if (!response.ok) {
          console.error('Failed to fetch product columns');
          return;
        }

        const data = await response.json();
        const html = new DOMParser()
          .parseFromString(data['compare-panel-columns'], 'text/html')
          .querySelector('#compare-panel-columns-container');
        const serializer = new XMLSerializer();

        const targetHtmlInfos = [
          {
            selector: '#compare-panel-columns-product-card',
            key: 'productCard',
          },
          {
            selector: '#compare-panel-columns-product-card-2',
            key: 'productCard2',
          },
          {
            selector: '#compare-panel-columns-content',
            key: 'content',
          },
          {
            selector: '#compare-panel-columns-add-to-cart',
            key: 'addToCart',
          },
        ];

        const result = {};
        for (const targetHtmlInfo of targetHtmlInfos) {
          const targetHtml = html.querySelector(targetHtmlInfo.selector);
          if (targetHtml) {
            if (targetHtmlInfo.key === 'content') {
              const numberOfChildren = Array.from(targetHtml.children).length;
              result.numberOfContentChildren = numberOfChildren;
              result.content = [];

              for (let i = 0; i < numberOfChildren; i++) {
                const child = targetHtml.children[i];
                const serializedHtml = serializer.serializeToString(child);
                result.content.push({
                  html: serializedHtml,
                  label: child.dataset.label,
                });
              }
            } else {
              const serializedHtml = serializer.serializeToString(targetHtml);
              result[targetHtmlInfo.key] = serializedHtml;
            }
          }
        }
        return result;
      },
      returnToCompare() {
        this.selectedProductIndex = null;
        this.step = 2;
      },
      get contentLabels() {
        if (!this.productHtmls || this.productHtmls.length === 0) return [];
        const labels = [];
        for (const productHtml of this.productHtmls) {
          for (const content of productHtml?.content ?? []) {
            const html = document.createElement('div');
            html.innerHTML = content.html;
            const contentContainer = html.querySelector('[data-label]');
            const label = contentContainer.dataset.label;
            if (!labels.includes(label)) {
              labels.push(label);
            }
          }
        }
        return labels;
      },
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["compare-panel"] && !Shopify.designMode) return;
  try {
    window.ComparePanelComponent = function (productId, productHandle) {
    return {
      init() {
        if (productId && productHandle) {
          this.$store.comparePanel.addCompareProduct(productId, productHandle);
          this.$store.comparePanel.disableChangeFirstProduct = true;
        }
      },
    };
  };

  window.ComparePanelCachedHtmlComponent = function () {
    return {
      _cachedHtml: '',
      init() {
        // Only change the html if the html actually changes
        Alpine.effect(() => {
          const store = Alpine.store('comparePanel');
          const html =
            store.selectedProductIndex !== null ? store.productHtmls[store.selectedProductIndex]?.addToCart : '';
          if (html !== this._cachedHtml) {
            this._cachedHtml = html;
            Alpine.mutateDom(() => {
              this.$root.innerHTML = html || '';
              this.$root._x_ignoreSelf = true;
              Alpine.initTree(this.$root);
              delete this.$root._x_ignoreSelf;
            });
          }
        });
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["content-page-text-group-snippet"] && !Shopify.designMode) return;
  try {
    window.ContentPageTextGroup = function (useParentToSearchStickyHeadingEnd) {
    return {
      topSpacing: 0,
      distanceToEligibleSibling: null,
      eligibleSibling: null,
      init() {
        this.topSpacing = parseFloat(getComputedStyle(this.$root).marginTop);

        // Get the distance to the sibling, whose bottom the sticky heading should end at
        let currentElement = useParentToSearchStickyHeadingEnd ? this.$root.parentElement : this.$root;
        let searchEnd = false;
        let eligibleSibling = null;

        while (!searchEnd) {
          const nextElement = currentElement.nextElementSibling;
          if (!nextElement) searchEnd = true;

          if (
            nextElement.matches('[data-sticky-heading-end]') ||
            nextElement.querySelector('[data-sticky-heading-end]')
          ) {
            eligibleSibling = nextElement;
            currentElement = nextElement;
          } else {
            searchEnd = true;
            break;
          }
        }

        if (eligibleSibling) {
          this.eligibleSibling = eligibleSibling;
          this.calculateDistanceToEligibleSibling();

          this.$watch('$store.breakpoints.isMobile', () => {
            this.calculateDistanceToEligibleSibling();
          });
        }
      },
      calculateDistanceToEligibleSibling() {
        const distance = Math.abs(
          this.$root.getBoundingClientRect().top - this.eligibleSibling.getBoundingClientRect().bottom
        );
        this.distanceToEligibleSibling = distance;
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["email-subscription-panel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', function () {
    Alpine.store('emailSubscriptionPanel', {
      isPanelOpen: false,
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["email-subscription-snippet"] && !Shopify.designMode) return;
  try {
    window.EmailSubscriptionSnippetComponent = function () {
    return {
      isConsentChecked: false,
      email: '',
      mutation: null,
      isPending: false,
      isSuccess: false,
      isError: false,
      errorMessage: '',
      klaviyoListIdForEmailSubscription: '',
      init: function () {
        this.klaviyoListIdForEmailSubscription = this.$root.dataset.klaviyoListIdForEmailSubscription;

        const mutation = window.createMutation({
          mutationFn: () =>
            this.subscribeToList({
              subscriptionType: 'email',
              email: this.email,
              listId: this.klaviyoListIdForEmailSubscription,
            }),
          subscribeFn: (result) => {
            this.isPending = result.isPending;
            this.isSuccess = result.isSuccess;
            this.isError = result.isError;
            this.errorMessage = result.error;

            if (this.isSuccess) {
              this.email = '';
            }
          },
        });
        this.mutation = mutation;
      },
      destroy() {
        this.mutation.unsubscribe();
      },
      onSubmit: function (e) {
        e.preventDefault();
        this.mutation.mutate();
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filter-and-sort-accordions"] && !Shopify.designMode) return;
  try {
    window.FilterChildrenComponent = function (filterLabel) {
    return {
      init() {
        const observer = new ResizeObserver(() => {
          if (this.$root.offsetParent !== null) {
            this.setUniformWidth();
          }
        });
        observer.observe(this.$root);

        const disableAccordionIfTotalCountIsZero = (totalCount) => {
          if (totalCount === 0) {
            this.active = false;
          }
          this.disabled = totalCount === 0;
        };
        const totalCount = this.getFilterTotalCount(filterLabel);
        disableAccordionIfTotalCountIsZero(totalCount);
        this.$watch(`getFilterTotalCount('${filterLabel}')`, disableAccordionIfTotalCountIsZero, {
          immediate: true,
          deep: true,
        });
      },
      setUniformWidth() {
        const buttons = this.$root.querySelectorAll('[data-option-button]');
        let maxWidth = 0;

        // 1. Find the widest element
        buttons.forEach((btn) => {
          // Reset width first to get natural size in case of re-renders
          btn.style.minWidth = 'auto';
          const width = btn.offsetWidth;
          if (width > maxWidth) maxWidth = width;
        });

        // 2. Apply that width to everyone
        if (maxWidth > 0) {
          buttons.forEach((btn) => {
            btn.style.minWidth = `${maxWidth}px`;
          });
        }
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gallery-snippet"] && !Shopify.designMode) return;
  try {
    window.GalleryComponent = function () {
    return {
      init: function () {
        new Swiper(this.$refs.swiper, {
          spaceBetween: 5,
          slidesPerView: 'auto',
          slidesOffsetBefore: 15,
          slidesOffsetAfter: 15,
          freeMode: true,
          breakpoints: {
            640: { slidesOffsetBefore: 20, slidesOffsetAfter: 20 },
          },
          mousewheel: {
            forceToAxis: true,
          },
        });
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-wishlist-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('WishlistHeaderLinkComponent', () => ({
      numberOfWishlistItems: 0,
      wishlistCounterObserver: null,
      init: function () {
        this.syncNumberOfWishlistItems();
        this.observeWishlistCounter();
      },
      syncNumberOfWishlistItems: function () {
        const counterElement = this.$root.querySelector('.wk-counter');
        const counterText = counterElement?.textContent?.trim() ?? '0';
        const parsedCounter = Number.parseInt(counterText, 10);
        this.numberOfWishlistItems = Number.isFinite(parsedCounter) ? parsedCounter : 0;
      },
      observeWishlistCounter: function () {
        if (!this.$refs.wishlistCounterContainer) return;

        this.wishlistCounterObserver = new MutationObserver(() => {
          this.syncNumberOfWishlistItems();
        });

        this.wishlistCounterObserver.observe(this.$refs.wishlistCounterContainer, {
          attributes: true,
          subtree: true,
          childList: true,
        });
      },
      destroy: function () {
        this.wishlistCounterObserver?.disconnect();
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["klayviyo-api"] && !Shopify.designMode) return;
  try {
    window.KlayviyoApi = function () {
    return {
      klayviyoPublicApiKey: null,
      klaviyoListIdForEmailSubscription: null,
      init: function () {
        const klayviyoApi = document.getElementById('klayviyo-api');
        this.klayviyoPublicApiKey = klayviyoApi.dataset.klayviyoApiPublicApiKey;
        this.klaviyoListIdForEmailSubscription = klayviyoApi.dataset.klayviyoApiListIdForEmailSubscription;
      },
      async subscribeToBackInStock({ email, variantId }) {
        const payload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                  },
                },
              },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`,
                },
              },
            },
          },
        };

        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2025-07-15',
          },
          body: JSON.stringify(payload),
        };

        const response = await fetch(
          `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.klayviyoPublicApiKey}`,
          requestOptions
        );
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.errors?.[0]?.detail);
        }

        return 'success';
      },
      subscribeToList: async function ({
        subscriptionType,
        email,
        phoneNumber,
        firstName,
        lastName,
        properties,
        listId,
      }) {
        const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${this.klayviyoPublicApiKey}`;

        const attributes = this.normalizeProfileAttributes({
          subscriptionType,
          email,
          phoneNumber,
          firstName,
          lastName,
          properties,
        });

        const body = {
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes,
                  id: 'string',
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId,
                },
              },
            },
          },
        };
        const options = {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            revision: '2025-07-15',
            'content-type': 'application/vnd.api+json',
          },
          body: JSON.stringify(body),
        };

        const response = await fetch(url, options);
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.errors?.[0]?.detail);
        }

        return 'success';
      },
      updateProfile: async function ({ email, phoneNumber, firstName, lastName, properties }) {
        const url = `https://a.klaviyo.com/client/profiles/?company_id=${this.klayviyoPublicApiKey}`;

        const body = this.removeUndefinedDeep({
          data: {
            type: 'profile',
            attributes: {
              email: email,
              phone_number: phoneNumber,
              first_name: firstName,
              last_name: lastName,
              properties,
            },
          },
        });

        const options = {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            revision: '2025-07-15',
            'content-type': 'application/vnd.api+json',
          },
          body: JSON.stringify(body),
        };

        const response = await fetch(url, options);
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.errors?.[0]?.detail);
        }

        return 'success';
      },
      normalizeProfileAttributes: function ({ subscriptionType, email, phoneNumber, firstName, lastName, properties }) {
        const finalProperties = properties ? { properties: properties } : {};
        const names =
          firstName && lastName
            ? {
                first_name: firstName,
                last_name: lastName,
              }
            : {};
        const subscriptions =
          subscriptionType === 'email'
            ? {
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED',
                    },
                  },
                },
              }
            : subscriptionType === 'sms'
            ? {
                subscriptions: {
                  sms: {
                    marketing: {
                      consent: 'SUBSCRIBED',
                    },
                  },
                },
              }
            : subscriptionType === 'both'
            ? {
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED',
                    },
                  },
                  sms: {
                    marketing: {
                      consent: 'SUBSCRIBED',
                    },
                  },
                },
              }
            : {};

        const contactInformation =
          subscriptionType === 'email'
            ? { email: email }
            : subscriptionType === 'sms' || subscriptionType === 'both'
            ? { email: email, phone_number: phoneNumber }
            : {};

        return {
          ...contactInformation,
          ...subscriptions,
          ...names,
          ...finalProperties,
        };
      },
      unsubscribe: async function ({ subscriptionType }) {
        const response = await fetch(
          `${window.Shopify.routes.root}apps/api/unsubscribe?unsubscribe_type=${subscriptionType}`
        );
        if (!response.ok) {
          throw new Error(`Failed to unsubscribe.`);
        }
        return 'success';
      },
      getCustomerData: async function () {
        const response = await fetch(`${window.Shopify.routes.root}apps/api/customer`);
        if (!response.ok) {
          throw new Error('Failed to get customer data');
        }
        return response.json();
      },
      removeUndefinedDeep: function (obj) {
        if (Array.isArray(obj)) {
          return obj.map((item) => this.removeUndefinedDeep(item)).filter((item) => item !== undefined);
        } else if (obj && typeof obj === 'object') {
          return Object.fromEntries(
            Object.entries(obj)
              .filter(([_, value]) => value !== undefined)
              .map(([key, value]) => [key, this.removeUndefinedDeep(value)])
          );
        }
        return obj;
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["line-item-remove-button"] && !Shopify.designMode) return;
  try {
    window.LineItemRemoveButtonComponent = function () {
    return {
      updateCartMutation: null,
      isPending: false,
      isSuccess: false,
      isError: false,
      errorMessage: '',
      onRemove: function (lineItemKey) {
        this.isPending = true;
        this.isError = false;
        this.errorMessage = '';
        this.isSuccess = false;
        this.$store.cart.updateCartMutation.mutate(
          {
            updates: { [lineItemKey]: 0 },
          },
          {
            onSuccess: (data) => {
              this.isSuccess = true;
              this.isPending = false;
              this.$store.cart.data = data;
            },
            onError: (error) => {
              this.isError = true;
              this.errorMessage = error.message;
            },
            onSettled: () => {
              this.isPending = false;
            },
          }
        );
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["line-item"] && !Shopify.designMode) return;
  try {
    window.LineItemComponent = function (personalizationProductId) {
    return {
      personalizationProductId: personalizationProductId,
      isPending: false,
      isSuccess: false,
      isError: false,
      errorMessage: '',
      get lineItemQuantity() {
        return this.line_item.quantity;
      },
      set lineItemQuantity(value) {
        this.isPending = true;
        this.isError = false;
        this.errorMessage = '';
        this.isSuccess = false;
        this.$store.cart.updateCartMutation.mutate(
          { updates: { [this.line_item.key]: value } },
          {
            onSuccess: (data) => {
              this.isSuccess = true;
              this.$store.cart.data = data;
            },
            onError: (error) => {
              this.isError = true;
              this.errorMessage = error.message;
            },
            onSettled: () => {
              this.isPending = false;
            },
          }
        );
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["location-redirection-pop-up"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data(
      'LocationRedirectionPopUpComponent',
      ({
        description_when_detected_location_is_united_states,
        description_when_detected_location_is_europe,
        description_when_detected_location_is_japan,
        go_to_button_label_when_detected_location_is_united_states,
        go_to_button_label_when_detected_location_is_europe,
        go_to_button_label_when_detected_location_is_japan,
      }) => {
        return {
          lastDismissedAt: Alpine.$persist(null).as('locationRedirectionPopUpLastDismissedAt'),
          detectedLocation: null,
          detectedHost: null,
          get description() {
            if (this.detectedLocation === 'US') {
              return description_when_detected_location_is_united_states;
            } else if (this.detectedLocation === 'EU') {
              return description_when_detected_location_is_europe;
            } else if (this.detectedLocation === 'JP') {
              return description_when_detected_location_is_japan;
            }
          },
          get goToButtonLabel() {
            if (this.detectedLocation === 'US') {
              return go_to_button_label_when_detected_location_is_united_states;
            } else if (this.detectedLocation === 'EU') {
              return go_to_button_label_when_detected_location_is_europe;
            } else if (this.detectedLocation === 'JP') {
              return go_to_button_label_when_detected_location_is_japan;
            }
          },
          async init() {
            const response = await fetch('/browsing_context_suggestions.json');
            const data = await response.json();
            const userCountryCode = data.detected_values.country.handle.toUpperCase();

            const euCountries = [
              'AD',
              'AL',
              'AT',
              'AX',
              'BA',
              'BE',
              'BG',
              'BY',
              'CH',
              'CY',
              'CZ',
              'DE',
              'DK',
              'EE',
              'ES',
              'FI',
              'FO',
              'FR',
              'GB',
              'GG',
              'GI',
              'GR',
              'HR',
              'HU',
              'IE',
              'IM',
              'IS',
              'IT',
              'JE',
              'LI',
              'LT',
              'LU',
              'LV',
              'MC',
              'MD',
              'ME',
              'MK',
              'MT',
              'NL',
              'NO',
              'PL',
              'PT',
              'RO',
              'RS',
              'RU',
              'SE',
              'SI',
              'SJ',
              'SK',
              'SM',
              'UA',
              'VA',
              'XK',
            ];
            console.log('userCountryCode', userCountryCode);
            if (userCountryCode === 'US' && window.location.host !== 'us.grivel.com') {
              this.detectedLocation = 'US';
              this.detectedHost = 'https://us.grivel.com';
            } else if (userCountryCode === 'JP' && window.location.host !== 'grivel.jp') {
              this.detectedLocation = 'JP';
              this.detectedHost = 'https://grivel.jp';
            } else if (
              euCountries.includes(userCountryCode) &&
              window.location.host !== 'grivel.com' &&
              window.location.host !== 'griveldev.myshopify.com' &&
              window.location.host !== 'grivel-migration-test-store.myshopify.com'
            ) {
              this.detectedLocation = 'EU';
              this.detectedHost = 'https://grivel.com';
            }
          },
          get open() {
            const thirtyDays = 30 * 24 * 60 * 60 * 1000;
            return (
              this.detectedLocation !== null &&
              (this.lastDismissedAt === null || Date.now() - this.lastDismissedAt > thirtyDays)
            );
          },
          onClose: function () {
            this.lastDismissedAt = Date.now();
          },
        };
      }
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["native-select"] && !Shopify.designMode) return;
  try {
    window.NativeSelectComponent = function () {
    return {
      openSelect(event) {
        const select = this.$refs.select;
        if (!select) return;

        if (typeof select.showPicker === 'function') {
          select.showPicker();
          return;
        }

        select.focus();
        select.click();
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["out-of-stock-and-pre-order"] && !Shopify.designMode) return;
  try {
    window.OutOfStockAndPreOrderButtonComponent = function () {
    return {
      // data from the dataset
      preorderDescription: '',
      preorderButtonLabel: '',
      outOfStockTitle: '',
      outOfStockDescription: '',
      outOfStockButtonLabel: '',
      minHeight: null,
      init: function () {
        const data = JSON.parse(this.$root.querySelector('script[type="application/json"]').textContent);
        this.preorderDescription = data['preorder-description'];
        this.preorderButtonLabel = data['preorder-button-label'];
        this.outOfStockTitle = data['out-of-stock-title'];
        this.outOfStockDescription = data['out-of-stock-description'];
        this.outOfStockButtonLabel = data['out-of-stock-button-label'];

        Motion.scroll(() => {
          this.$store.product.showHeaderAddToCart = this.$refs.addToCartContainer.getBoundingClientRect().top < 0;
        });

        const animateCardContainer = () => {
          const transition = { duration: this.initialized ? 0.3 : 0, ease: 'ease-out' };
          if (this.$store.product.isSelectedVariantOutOfStockOrPreOrder && this.reachingGalleryTop) {
            Motion.animate([[this.$refs.outOfStockAndPreOrderCardContainer, { height: 'auto' }, transition]]);
          } else {
            Motion.animate([
              [this.$refs.outOfStockAndPreOrderCardContainer, { height: `${this.minHeight}px` }, transition],
            ]);
          }
        };

        Motion.resize(this.$refs.addToCartContainer, (element, { height }) => {
          this.minHeight = height;
          animateCardContainer();
        });

        let previousWatchValue = null;
        this.$watch(
          '$store.product.isSelectedVariantOutOfStockOrPreOrder && reachingGalleryTop',
          (value) => {
            if (value === previousWatchValue) return;
            previousWatchValue = value;
            animateCardContainer();
          },
          { immediate: true }
        );
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["out-of-stock-panel"] && !Shopify.designMode) return;
  try {
    window.OutOfStockAndPreOrderPanelComponent = function () {
    return {
      firstName: '',
      lastName: '',
      email: '',
      isEmailSubscriptionChecked: false,
      isTermsAndConditionsChecked: false,
      mutation: null,
      isPending: false,
      isSuccess: false,
      isError: false,
      errorMessage: '',
      // data from the dataset
      klaviyoListIdForEmailSubscription: '',
      outOfStockPanelTitle: '',
      outOfStockPanelButtonLabel: '',
      outOfStockSuccessMessage: '',
      outOfStockErrorMessage: '',
      init: function () {
        const data = JSON.parse(this.$root.querySelector('script[type="application/json"]').textContent);
        this.klaviyoListIdForEmailSubscription = data['klaviyo-list-id-for-email-subscription'];
        this.outOfStockPanelTitle = data['out-of-stock-panel-title'];
        this.outOfStockPanelButtonLabel = data['out-of-stock-panel-button-label'];
        this.outOfStockSuccessMessage = data['out-of-stock-success-message'];
        this.outOfStockErrorMessage = data['out-of-stock-error-message'];

        const mutation = window.createMutation({
          mutationFn: async ({ selectedVariant, id, handle, title }) => {
            const requests = [];
            requests.push(this.subscribeToBackInStock({ email: this.email, variantId: selectedVariant.id }));

            if (this.isEmailSubscriptionChecked) {
              requests.push(
                this.subscribeToList({
                  subscriptionType: 'email',
                  email: this.email,
                  firstName: this.firstName,
                  lastName: this.lastName,
                  listId: this.klaviyoListIdForEmailSubscription,
                })
              );
            } else {
              requests.push(
                this.updateProfile({ email: this.email, firstName: this.firstName, lastName: this.lastName })
              );
            }

            const result = await Promise.all(requests);
            return result;
          },
          subscribeFn: (result) => {
            this.isPending = result.isPending;
            this.isSuccess = result.isSuccess;
            this.isError = result.isError;
            this.errorMessage = result.error;

            if (this.isSuccess) {
              this.clearForm();
            }
          },
        });
        this.mutation = mutation;

        this.$watch('isPanelOpen', () => {
          this.isSuccess = false;
          this.isError = false;
          this.errorMessage = '';
          this.isPending = false;
        });
      },
      destroy() {
        this.mutation.unsubscribe();
      },
      get imageSrc() {
        return this.$store.outOfStock.selectedVariant?.featured_image?.src ?? this.$store.outOfStock.featuredImage;
      },
      get imagePaddingClass() {
        const useVariantImage = !!this.$store.outOfStock.selectedVariant?.featured_image?.src;
        const imageWidth =
          (useVariantImage
            ? this.$store.outOfStock.selectedVariant?.featured_image?.width
            : this.$store.outOfStock.featuredImageWidth) ?? 0;
        const imageHeight =
          (useVariantImage
            ? this.$store.outOfStock.selectedVariant?.featured_image?.height
            : this.$store.outOfStock.featuredImageHeight) ?? 0;
        return imageWidth < imageHeight + 10 && imageWidth > imageHeight - 10
          ? 'px-13 py-10'
          : imageWidth > imageHeight
          ? 'px-13 py-5'
          : 'px-28 py-5';
      },
      get isPanelOpen() {
        return !!this.$store.outOfStock.selectedVariant;
      },
      set isPanelOpen(value) {
        if (!value) {
          this.$store.outOfStock.selectedVariant = null;
        }
      },
      clearForm: function () {
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.isEmailSubscriptionChecked = false;
        this.isTermsAndConditionsChecked = false;
      },
      onSubmit: function (e) {
        e.preventDefault();
        const selectedVariant = this.$store.outOfStock.selectedVariant;
        const id = this.$store.outOfStock.id;
        const handle = this.$store.outOfStock.handle;
        const title = this.$store.outOfStock.title;

        this.mutation.mutate({ selectedVariant, id, handle, title });
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["out-of-stock-store"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.store('outOfStock', {
      selectedVariant: null,
      id: null,
      handle: null,
      selectedOptions: null,
      title: null,
      featuredImage: null,
      type: null,
      selectedVariantPrice: null,
      setData: function (data) {
        this.selectedVariant = data.selectedVariant;
        this.id = data.id;
        this.handle = data.handle;
        this.selectedOptions = data.selectedOptions;
        this.title = data.title;
        this.featuredImage = data.featuredImage;
        this.featuredImageWidth = data.featuredImageWidth;
        this.featuredImageWidth = data.featuredImageWidth;
        this.type = data.type;
        this.selectedVariantPrice = data.selectedVariantPrice;
      },
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["panel"] && !Shopify.designMode) return;
  try {
    window.PanelComponent = function (isOpen) {
    return {
      init() {
        this.$watch(isOpen, (value, oldValue) => {
          if (value === oldValue) return;
          if (value) {
            this.$store.settings.enableBodyScrollLock();
          } else {
            this.$store.settings.disableBodyScrollLock();
          }
        });
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["personalization-image"] && !Shopify.designMode) return;
  try {
    window.PersonalizationImageComponent = function () {
    return {
      wrapperHeight: undefined,
      wrapperWidth: undefined,
      overlayScale: 1,
      init() {
        const img = this.$refs.wrapper.querySelector('img');
        if (img) {
          if (img.complete && img.naturalWidth) this.calcSize();
          else img.addEventListener('load', () => this.calcSize());
        }
        new ResizeObserver(() => this.calcSize()).observe(this.$el);
      },
      calcSize() {
        const img = this.$refs.wrapper.querySelector('img');
        if (!img || !img.naturalWidth) return;
        const ratio = img.naturalWidth / img.naturalHeight;
        const cW = this.$el.clientWidth;
        const cH = this.$el.clientHeight;
        let renderedW;
        if (ratio > cW / cH) {
          renderedW = cW;
          this.wrapperWidth = cW;
          this.wrapperHeight = cW / ratio;
        } else {
          renderedW = cH * ratio;
          this.wrapperHeight = cH;
          this.wrapperWidth = renderedW;
        }
        this.updateOverlayScale(renderedW);
      },
      updateOverlayScale(renderedW) {
        const overlay = this.$refs.overlay;
        if (!overlay) return;
        const baseScale = parseFloat(overlay.dataset.baseScale) || 1;
        const widthScale = renderedW / 820;
        const finalScale = baseScale * widthScale;
        this.overlayScale = finalScale;
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["personalization-input"] && !Shopify.designMode) return;
  try {
    window.PersonalizationInputComponent = function () {
    return {
      onClick() {
        if (this.$store.product.showPersonalizationInput) {
          this.$store.product.closePersonalizationInput();
        } else {
          this.$store.product.openPersonalizationInput(this.showVariantImage ? 'instant' : 'smooth');
          this.showVariantImage = false;
        }
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["play-button"] && !Shopify.designMode) return;
  try {
    window.PlayButtonComponent = function () {
    return {
      init: function () {
        let animation;
        Motion.hover(this.$root, () => {
          if (animation) {
            animation.cancel();
          }

          animation = Motion.animate([
            [
              this.$refs.triangle,
              {
                color: 'var(--color-black)',
              },
              {
                duration: 0.15,
                ease: 'ease-out',
              },
            ],
            [
              this.$root,
              {
                backgroundColor: 'var(--color-summit-yellow)',
              },
              {
                duration: 0.15,
                ease: 'ease-out',
              },
            ],
          ]);

          return () => {
            if (animation) {
              animation.cancel();
            }

            animation = Motion.animate([
              [
                this.$refs.triangle,
                {
                  color: 'var(--color-white)',
                },
                {
                  duration: 0.15,
                },
              ],
              [
                this.$root,
                {
                  backgroundColor: 'var(--color-black)',
                },
                {
                  duration: 0.15,
                  ease: 'ease-out',
                },
              ],
            ]);
          };
        });
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-actions"] && !Shopify.designMode) return;
  try {
    window.ProductActionsComponent = function ({ hasProductHero }) {
    return {
      rootWidth: null,
      rootHeight: null,
      remainingHeight: null,
      stickyParentHeight: null,
      reachingGalleryTop: hasProductHero ? null : true,
      initialized: false,
      //heights
      badgesContainerHeight: null,
      productCoreInfoHeight: null,
      optionsHeight: null,
      outOfStockAndPreOrderHeight: null,
      productPromoMessagesHeight: null,
      addToCartButtonHeight: null,
      init: function () {
        if (hasProductHero) {
          this.animateCard();
        }
      },
      animateCard() {
        Motion.scroll(() => {
          const galleryContainer = document.querySelector('[data-product-gallery="true"]');
          const stickyContentTop = this.$refs.productActionsContent.getBoundingClientRect().top;
          const newReachingGalleryTop = stickyContentTop >= galleryContainer.getBoundingClientRect().top;
          if (newReachingGalleryTop == this.reachingGalleryTop) return;
          const transition = { duration: this.initialized ? 0.3 : 0.00001 };
          if (newReachingGalleryTop) {
            this.reachingGalleryTop = true;
            Motion.animate(this.$refs.optionsContainer, { height: 'auto' }, transition).then(() => {
              this.initialized = true;
            });
          } else {
            this.reachingGalleryTop = false;
            Motion.animate(this.$refs.optionsContainer, { height: 0 }, transition).then(() => {
              this.initialized = true;
            });
          }
        });
      },
      calculateStickyParentHeight() {
        if (!hasProductHero) return;
        const cardPadding = 20;
        const spacingBetweenOptionsAndOutOfStockAndPreOrder = 30;
        const offset = 38; // gallery top padding + widget bottom margin

        if (!this.$store.product.isSelectedVariantOutOfStockOrPreOrder) {
          this.rootHeight =
            this.badgesContainerHeight +
            this.productCoreInfoHeight +
            this.optionsHeight +
            this.addToCartButtonHeight +
            this.productPromoMessagesHeight +
            cardPadding +
            spacingBetweenOptionsAndOutOfStockAndPreOrder;

          this.remainingHeight = this.rootHeight - this.optionsHeight;

          this.stickyParentHeight = this.remainingHeight + this.rootHeight + offset;
        } else {
          this.rootHeight =
            this.badgesContainerHeight +
            this.productCoreInfoHeight +
            this.optionsHeight +
            this.outOfStockAndPreOrderHeight +
            cardPadding +
            spacingBetweenOptionsAndOutOfStockAndPreOrder;
          this.remainingHeight =
            this.rootHeight - this.optionsHeight - this.outOfStockAndPreOrderHeight + this.addToCartButtonHeight;
          this.stickyParentHeight = this.remainingHeight + this.rootHeight + offset;
        }
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-add-to-cart"] && !Shopify.designMode) return;
  try {
    window.ProductAddToCartComponent = function (access_state_through_store) {
    return {
      isPending: false,
      isSuccess: false,
      isError: false,
      errorMessage: '',
      addToCart: async function () {
        const scroll_to_gallery = this.$root.dataset.scrollToGallery;
        if (scroll_to_gallery === 'true') {
          const gallery = document.querySelector('[data-product-gallery]');
          gallery.scrollIntoView({ behavior: 'smooth' });
          return;
        }

        // if the product variant is not available, show the out of stock and pre order panel
        const selectedVariant = access_state_through_store ? this.$store.product.selectedVariant : this.selectedVariant;
        const available = access_state_through_store
          ? this.$store.product.selectedVariant.available
          : this.selectedVariant.available;
        const title = access_state_through_store ? this.$store.product.title : this.title;
        const featuredImage = access_state_through_store ? this.$store.product.featuredImage : this.featuredImage;
        const featuredImageWidth = access_state_through_store
          ? this.$store.product.featuredImageWidth
          : this.featuredImageWidth;
        const featuredImageHeight = access_state_through_store
          ? this.$store.product.featuredImageHeight
          : this.featuredImageHeight;
        const type = access_state_through_store ? this.$store.product.type : this.type;
        const selectedVariantPrice = access_state_through_store
          ? this.$store.product.selectedVariantPrice
          : this.selectedVariantPrice;
        const selectedOptions = access_state_through_store ? this.$store.product.selectedOptions : this.selectedOptions;
        const isSelectedVariantPreOrderEnabled = access_state_through_store
          ? this.$store.product.isSelectedVariantPreOrderEnabled
          : this.isSelectedVariantPreOrderEnabled;
        const selectedVariantInventoryQuantity = access_state_through_store
          ? this.$store.product.selectedVariantInventoryQuantity
          : this.selectedVariantInventoryQuantity;
        const productId = access_state_through_store ? this.$store.product.id : this.id;
        const handle = access_state_through_store ? this.$store.product.handle : this.handle;
        if (!available) {
          this.$store.outOfStock.setData({
            selectedVariant: selectedVariant,
            selectedOptions: selectedOptions,
            title: title,
            id: productId,
            handle: handle,
            featuredImage: featuredImage,
            featuredImageWidth: featuredImageWidth,
            featuredImageHeight: featuredImageHeight,
            type: type,
            selectedVariantPrice: selectedVariantPrice,
          });
          return;
        }

        const id = access_state_through_store ? this.$store.product.selectedVariant.id : this.selectedVariant.id;
        const quantity = access_state_through_store
          ? this.$store.product.selectedVariantQuantity
          : this.selectedVariantQuantity;
        const personalizationText = access_state_through_store
          ? this.$store.product.personalizationText
          : this.personalizationText;
        const personalizationProductId = access_state_through_store
          ? this.$store.product.personalizationProductId
          : this.personalizationProductId;
        const personalizationPrice = access_state_through_store
          ? this.$store.product.personalizationPrice
          : this.personalizationPrice;

        let formData = {
          items: [
            {
              id,
              quantity,
            },
          ],
        };
        const alsoAddPersonalizationProduct = personalizationText && personalizationProductId && personalizationPrice;
        if (alsoAddPersonalizationProduct) {
          formData.items.push({
            id: personalizationProductId,
            quantity: quantity * personalizationPrice,
          });
          formData.items[0].properties = {
            personalization: personalizationText,
            // Underscore-prefixed so Shopify hides it from order confirmations / admin line-item displays,
            // while keeping it queryable from cart.js for price breakdown and quantity auto-sync.
            _personalizationPrice: personalizationPrice,
          };
        }

        this.isPending = true;
        this.isError = false;
        this.errorMessage = '';
        this.isSuccess = false;
        this.$store.cart.addToCartMutation.mutate(formData, {
          onSuccess: async (data) => {
            await window.queryClient.invalidateQueries({ queryKey: ['cart'] });
            this.isSuccess = true;
            this.$store.cart.openCartPanel();

            if (alsoAddPersonalizationProduct) {
              if (access_state_through_store) {
                this.$store.product.personalizationText = null;
              } else {
                this.personalizationText = null;
              }
            }
          },
          onError: (error) => {
            this.isError = true;
            this.errorMessage = error.message;
          },
          onSettled: () => {
            this.isPending = false;
          },
        });
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-additional-info"] && !Shopify.designMode) return;
  try {
    window.ProductAdditionalInfoComponent = function () {
    return {
      isPanelOpen: false,
      init: function () {},
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    window.ProductCardComponent = function () {
    return {
      isTagsOverflowing: false,
      init: function () {
        new Swiper(this.$refs.tags, {
          slidesPerView: 'auto',
          spaceBetween: 18,
          mousewheel: {
            forceToAxis: true,
          },
        });
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-category-panel"] && !Shopify.designMode) return;
  try {
    window.ProductCategoryPanelComponent = function (index) {
    return {
      init() {},
      get isPanelOpen() {
        const activeCategoryIndex = Number(this.activeCategory?.index);
        const panelIndex = Number(index);
        return Number.isNaN(activeCategoryIndex) || Number.isNaN(panelIndex)
          ? false
          : activeCategoryIndex === panelIndex;
      },
      set isPanelOpen(value) {
        this.activeCategory = null;
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-featured-cards-snippet"] && !Shopify.designMode) return;
  try {
    window.ProductFeaturedCardsComponent = function () {
    return {
      init() {
        this.swiper = new Swiper(this.$refs.productFeaturedCardsSwiper, {
          slidesPerView: 1.2,
          spaceBetween: 10,
          slidesOffsetAfter: 15,
          slidesOffsetBefore: 15,
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
        });
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-finder-multiple-select"] && !Shopify.designMode) return;
  try {
    window.productFinderMultipleSelectComponent = function (stepIndex, firstOptionId) {
    return {
      init() {
        this.$store.productFinder.onMultiSelectOptionChange(stepIndex, firstOptionId);
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-finder-results"] && !Shopify.designMode) return;
  try {
    window.ProductFinderResultsComponent = function () {
    return {
      swiper: null,
      init() {
        this.initSwiper();
        this.$watch('$store.productFinder.results', () => {
          this.initSwiper();
        });
      },
      initSwiper() {
        this.$nextTick(() => {
          const swiperEl = this.$refs.swiper;
          if (!swiperEl || this.$store.productFinder.results.length === 0) {
            return;
          }
          if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
          }
          this.swiper = new Swiper(swiperEl, {
            slidesPerView: 1.02,
            spaceBetween: 5,
            freeMode: true,
            breakpoints: {
              640: {
                slidesPerView: 2.2,
              },
            },
            mousewheel: {
              forceToAxis: true,
            },
          });
        });
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-finder-scale"] && !Shopify.designMode) return;
  try {
    window.ProductFinderScaleComponent = function (stepIndex) {
    return {
      value: 0,
      movement: 0,
      scaleWidth: 0,
      scaleHeight: 0,
      scaleStartX: 0,
      scaleStartY: 0,
      isDragging: false,
      init() {
        this.$store.productFinder.onScaleChange(stepIndex, this.value);

        this.$watch('$store.breakpoints.isMobile', (isMobile) => {
          this.getScaleStart();
          if (isMobile) {
            this.movement = this.value * this.scaleHeight;
          } else {
            this.movement = this.value * this.scaleWidth;
          }
        });

        document.addEventListener('pointermove', this.onPointerMove.bind(this));
        document.addEventListener('pointerup', this.onPointerUp.bind(this));

        this.$watch('$store.productFinder.stage', (stage) => {
          if (stage === stepIndex) {
            this.$store.productFinder.onScaleChange(stepIndex, this.value);
          }
        });
      },
      getScaleStart() {
        this.scaleStartY = this.$refs.scale.getBoundingClientRect().bottom;
        this.scaleHeight = this.$refs.scale.getBoundingClientRect().height;
        this.scaleStartX = this.$refs.scale.getBoundingClientRect().left;
        this.scaleWidth = this.$refs.scale.getBoundingClientRect().width;
      },
      onPointerDown(event) {
        this.isDragging = true;
      },
      onPointerMove(event) {
        if (this.isDragging) {
          this.calculateValue(event);
        }
      },
      onPointerUp(event) {
        if (this.isDragging) {
          this.isDragging = false;
          this.$store.productFinder.onScaleChange(stepIndex, this.value);
        }
      },
      calculateValue(event) {
        this.getScaleStart();
        if (this.$store.breakpoints.isMobile) {
          this.movement = Math.min(Math.max(this.scaleStartY - event.clientY, 0), this.scaleHeight);
          this.value = (this.movement / this.scaleHeight).toFixed(2);
        } else {
          this.movement = Math.min(Math.max(event.clientX - this.scaleStartX, 0), this.scaleWidth);
          this.value = (this.movement / this.scaleWidth).toFixed(2);
        }
      },
      onScaleClick(event) {
        this.calculateValue(event);
        this.$store.productFinder.onScaleChange(stepIndex, this.value);
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-finder-single-select"] && !Shopify.designMode) return;
  try {
    window.productFinderSingleSelectComponent = function (stepIndex, firstOptionId) {
    return {
      init() {
        this.$store.productFinder.onSingleSelectOptionChange(stepIndex, firstOptionId, false);
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-finder-store"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    let originalBodyOverflow = 'auto';
    return Alpine.store('productFinder', {
      numberOfSteps: 0,
      isOpen: false,
      stage: 'cover', // cover, 0, 1, 2, 3, ..., results
      selectedOptions: [],
      products: [],
      init() {
        const scriptEl = document.querySelector('script[data-product-finder]');
        const textContent = scriptEl?.textContent;
        if (!textContent) {
          return;
        }

        const parsedData = JSON.parse(textContent);
        this.products = (parsedData.products ?? []).map((product) => {
          const variants = Array.isArray(product.variants) ? product.variants : [];
          return {
            ...product,
            matchedOptions: Array.isArray(product.matchedOptions) ? product.matchedOptions : [],
            price: product.price ?? '',
            compareAtPrice: product.compareAtPrice ?? '',
            variants: variants.map((variant) => {
              return {
                ...variant,
                price: variant.price ?? '',
                compareAtPrice: variant.compareAtPrice ?? '',
                matchedOptions: Array.isArray(variant.matchedOptions) ? variant.matchedOptions : [],
              };
            }),
          };
        });
        console.log('this.products', this.products);
      },
      isCandidateMatched(matchedOptions = []) {
        const options = Array.isArray(matchedOptions) ? matchedOptions : [];
        return this.selectedOptions.every((option) => {
          switch (option.type) {
            case 'single_select':
              return options.some((mo) => {
                return String(mo.id) === String(option.id);
              });
            case 'multiple_select':
              return options.some((mo) => {
                return option.ids.has(String(mo.id));
              });
            case 'scale':
              return options.some((mo) => {
                return (
                  mo.type === 'product_finder_scale_range' &&
                  Number(option.value) >= Number(mo.min) &&
                  Number(option.value) <= Number(mo.max)
                );
              });
            default:
              return true;
          }
        });
      },
      get results() {
        return this.products.flatMap((product) => {
          const variants = Array.isArray(product.variants) ? product.variants : [];
          const hasVariantMatchedOptions = variants.some((variant) => {
            return Array.isArray(variant.matchedOptions) && variant.matchedOptions.length > 0;
          });
          const matchedVariants = variants.filter((variant) => {
            return this.isCandidateMatched(variant.matchedOptions);
          });

          if (matchedVariants.length > 0) {
            return matchedVariants.map((variant) => {
              const variantTitle = variant.title;
              const hasVariantTitle = variantTitle && variantTitle !== 'Default Title';
              return {
                ...product,
                id: variant.id,
                resultKey: `variant-${variant.id}`,
                isVariantMatch: true,
                variantTitle: hasVariantTitle ? variantTitle : '',
                displayTitle: product.title,
                url: variant.url ?? product.url,
                price: variant.price ?? product.price,
                compareAtPrice: variant.compareAtPrice ?? '',
                featured_image: variant.featured_image || product.featured_image,
              };
            });
          }

          if (!hasVariantMatchedOptions && this.isCandidateMatched(product.matchedOptions)) {
            return [
              {
                ...product,
                resultKey: `product-${product.id}`,
                isVariantMatch: false,
                variantTitle: '',
                displayTitle: product.title,
              },
            ];
          }

          return [];
        });
      },
      isSingleSelectOptionSelected(stepIndex, id) {
        return this.selectedOptions[stepIndex] && String(this.selectedOptions[stepIndex].id) === String(id);
      },
      onSingleSelectOptionChange(stepIndex, id, runNextStep = true) {
        this.selectedOptions[stepIndex] = {
          id: String(id),
          type: 'single_select',
        };
        if (runNextStep) {
          this.nextStep();
        }
      },
      isMultiSelectOptionSelected(stepIndex, id) {
        return this.selectedOptions[stepIndex] && this.selectedOptions[stepIndex].ids.has(String(id));
      },
      onMultiSelectOptionChange(stepIndex, id) {
        const stringId = String(id);
        if (!this.selectedOptions[stepIndex]) {
          this.selectedOptions[stepIndex] = {
            ids: new Set(),
            type: 'multiple_select',
          };
        }
        if (this.selectedOptions[stepIndex].ids.has(stringId)) {
          this.selectedOptions[stepIndex].ids.delete(stringId);
        } else {
          this.selectedOptions[stepIndex].ids.add(stringId);
        }
      },
      onScaleChange(stepIndex, value) {
        this.selectedOptions[stepIndex] = {
          value: value,
          type: 'scale',
        };
      },
      nextStep() {
        if (this.stage === 'cover') {
          this.stage = 1;
        } else if (Number.isInteger(this.stage)) {
          if (this.stage === this.numberOfSteps - 1) {
            this.stage = 'results';
          } else {
            this.stage = this.stage + 1;
          }
        }
      },
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-finder"] && !Shopify.designMode) return;
  try {
    window.ProductFinderComponent = function (number_of_steps) {
    let originalBodyOverflow = 'auto';
    return {
      init() {
        this.$store.productFinder.numberOfSteps = number_of_steps;

        this.$watch('$store.productFinder.isOpen', (value, oldValue) => {
          if (value === oldValue) return;
          if (value) {
            this.$store.settings.enableBodyScrollLock();
          } else {
            this.$store.settings.disableBodyScrollLock();
          }
        });
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-list"] && !Shopify.designMode) return;
  try {
    window.ProductListComponent = function () {
    return {
      init: function () {
        const swiper = new Swiper(this.$refs.swiperWrapper, {
          breakpoints: {
            640: {
              slidesPerView: 3,
            },
          },
          slidesPerView: 2.1,
          spaceBetween: 5,
          scrollbar: {
            el: this.$refs.swiperScrollbar,
            draggable: true,
            snapOnRelease: false,
          },
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
        });

        const prevButtons = this.$el.querySelectorAll('[data-navigation-button="prev"]');
        const nextButtons = this.$el.querySelectorAll('[data-navigation-button="next"]');

        prevButtons.forEach((button) => {
          button.addEventListener('click', () => {
            swiper.slidePrev();
          });
        });

        nextButtons.forEach((button) => {
          button.addEventListener('click', () => {
            swiper.slideNext();
          });
        });
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-options"] && !Shopify.designMode) return;
  try {
    window.ProductOptionsComponent = function (optionButtonFullWidthOnDesktop) {
    return {
      init() {
        const observer = new ResizeObserver(() => {
          if (this.$root.offsetParent !== null && !optionButtonFullWidthOnDesktop) {
            this.setUniformWidth();
          }
        });
        observer.observe(this.$root);
      },
      setUniformWidth() {
        const buttons = this.$root.querySelectorAll('[data-option-button]:not([data-is-size-option])');
        let maxWidth = 0;

        // 1. Find the widest element
        buttons.forEach((btn) => {
          // Reset width first to get natural size in case of re-renders
          btn.style.minWidth = 'auto';
          const width = btn.offsetWidth;
          if (width > maxWidth) maxWidth = width;
        });

        // 2. Apply that width to everyone
        if (maxWidth > 0) {
          buttons.forEach((btn) => {
            btn.style.minWidth = `${maxWidth}px`;
          });
        }
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-promo-messages"] && !Shopify.designMode) return;
  try {
    window.ProductPromoMessagesComponent = function () {
    return {
      activePromoMessageIndex: 0,
      init: function () {
        let animation;
        const productPromoMessages = Array.from(this.$refs.productPromoMessages.children);
        if (productPromoMessages.length <= 1) return;

        setInterval(() => {
          animation?.cancel();
          const previousPromoMessage = productPromoMessages[this.activePromoMessageIndex];
          if (this.activePromoMessageIndex >= productPromoMessages.length - 1) {
            this.activePromoMessageIndex = 0;
          } else {
            this.activePromoMessageIndex++;
          }
          const activePromoMessage = productPromoMessages[this.activePromoMessageIndex];

          animation = Motion.animate([
            [
              activePromoMessage,
              {
                x: '70%',
                opacity: 0,
              },
              {
                duration: 0.001,
              },
            ],
            [
              activePromoMessage,
              {
                x: 0,
                opacity: 1,
              },
              {
                duration: 0.3,
                ease: 'easeOut',
              },
            ],
            [
              previousPromoMessage,
              {
                opacity: 0,
              },
              {
                duration: 0.3,
                ease: 'easeOut',
                at: '<',
              },
            ],
          ]);
        }, 3000);
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quantity-input"] && !Shopify.designMode) return;
  try {
    window.ProductQuantityInputComponent = function (quantityPropertyName) {
    return {
      inputWidth: null,
      onInputChange(value) {
        this.inputWidth = value.toString().length * this.$refs['input-shadow'].getBoundingClientRect().width;
      },
      onChange(value) {
        if (value < 1) return;
        this[quantityPropertyName] = parseInt(value);
      },
      onDecrement() {
        const newValue = this[quantityPropertyName] - 1;
        if (newValue < 1) return;
        this[quantityPropertyName] = parseInt(newValue);
      },
      onIncrement() {
        const newValue = this[quantityPropertyName] + 1;
        this[quantityPropertyName] = parseInt(newValue);
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-state-data"] && !Shopify.designMode) return;
  try {
    window.productStateSharedFunctions = window.productStateSharedFunctions || {};
  window.ProductStateDataComponent = function (type, initialVariantId) {
    return {
      init() {
        const store = type === 'store' ? this.$store.product : this;
        const script = this.$root.querySelector('script[type="application/json"]');
        if (!script) return;

        let data;
        try {
          data = JSON.parse(script.textContent);
        } catch (error) {
          console.error('[ProductStateDataComponent] Invalid product JSON payload', error);
          return;
        }
        if (!data.id) return;
        store.title = data.title;
        store.id = data.id;
        store.handle = data.handle;
        store.featuredImage = data.featuredImage;
        store.featuredImageWidth = data.featuredImageWidth;
        store.featuredImageHeight = data.featuredImageHeight;
        store.type = data.type;
        store.available = data.available;
        store.has_only_default_variant = data.has_only_default_variant;
        store.variants = data.variants;
        store.options = data.options;
        store.prices = data.prices;
        store.personalizationPrice = parseInt(data.personalizationPrice);
        store.personalizationProductId = data.personalizationProductId;
        const initialVariant =
          initialVariantId && store.variants.find((v) => String(v.id) === String(initialVariantId));

        store.selectedOptions = store.options.reduce((acc, option, index) => {
          const valueFromVariant = initialVariant ? initialVariant[`option${index + 1}`] : null;
          acc[option.name] = valueFromVariant || option.values[0];
          return acc;
        }, {});

        store.updateSelectedVariant(false);
      },
    };
  };

  window.productStateSharedFunctions.getHandlers = ({
    doNotUpdateUrlAnyway = false,
    allowSelectUnavailableVariant = false,
  } = {}) => {
    return {
      selectedVariant: null,
      title: '',
      featuredImage: '',
      type: '',
      available: true,
      has_only_default_variant: false,
      variants: [],
      options: [],
      prices: {},
      selectedOptions: {},
      selectedVariantQuantity: 1,
      showPersonalizationInput: false,
      personalizationText: null,
      personalizationProductId: null,
      showHeaderAddToCart: false,
      allowSelectUnavailableVariant: allowSelectUnavailableVariant,
      // Size Guide
      isSizeGuidePanelOpen: false,
      get selectedVariantPrice() {
        if (!this.selectedVariant) return null;
        return this.prices[this.selectedVariant.id];
      },
      selectOption(name, value) {
        if (!this.isOptionValueAvailable(name, value) && !this.allowSelectUnavailableVariant) return;
        this.selectedOptions = { ...this.selectedOptions, [name]: value };
        this.updateSelectedVariant();
      },
      updateSelectedVariant(updateUrl = true) {
        const match = this.findMatchingVariant(this.selectedOptions);
        this.selectedVariant = match || null;
        if (this.selectedVariant && updateUrl) {
          this.updateUrlWithVariant(this.selectedVariant.id);
        }
      },
      updateUrlWithVariant(variantId) {
        if (doNotUpdateUrlAnyway) return;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      },
      findMatchingVariant(selected) {
        return this.variants.find((variant) =>
          this.options.every((option, index) => variant[`option${index + 1}`] === selected[option.name])
        );
      },
      isOptionValueAvailable(name, value) {
        const tentative = { ...this.selectedOptions, [name]: value };
        const isAvailable = this.variants.some(
          (variant) =>
            variant.available &&
            this.options.every((option, index) => {
              const wanted = tentative[option.name];
              return variant[`option${index + 1}`] === wanted;
            })
        );
        return isAvailable;
      },
      get isSelectedVariantPreOrderEnabled() {
        return (
          this.selectedVariant &&
          this.selectedVariant.inventory_quantity <= 0 &&
          this.selectedVariant.inventory_policy == 'continue'
        );
      },
      // True when the variant is truly unavailable (e.g. tracked inventory with
      // deny policy and 0 qty). Untracked variants such as gift cards report
      // `available: true` even with `inventory_quantity === 0`, so we rely on
      // Shopify's `available` flag instead of the quantity alone.
      get isSelectedVariantOutOfStock() {
        return !!this.selectedVariant && !this.selectedVariant.available;
      },
      get isSelectedVariantOutOfStockOrPreOrder() {
        return this.isSelectedVariantOutOfStock || this.isSelectedVariantPreOrderEnabled;
      },
      openPersonalizationInput(scrollBehavior) {
        this.showPersonalizationInput = true;

        if (!Alpine.store('settings').isMobile) {
          Alpine.nextTick(() => {
            const personalizationImage = document.querySelector('[data-personalization-image="true"]');
            if (personalizationImage) {
              personalizationImage.scrollIntoView({
                behavior: scrollBehavior,
                block: 'start',
              });
            }
          });
        }
      },
      closePersonalizationInput() {
        this.showPersonalizationInput = false;
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-state"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('productState', () =>
      window.productStateSharedFunctions.getHandlers({
        doNotUpdateUrlAnyway: true,
        allowSelectUnavailableVariant: true,
      })
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-store"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.store('product', window.productStateSharedFunctions.getHandlers({ allowSelectUnavailableVariant: true }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-actions"] && !Shopify.designMode) return;
  try {
    window.QuickActionsComponent = function () {
    return {
      isPending: false,
      isSuccess: false,
      isError: false,
      errorMessage: '',
      addToCartMutation: null,
      init() {
        const addToCartMutation = window.createMutation({
          mutationFn: (data) => this.$store.cartApi.addToCart(data),
          subscribeFn: (result) => {
            this.isPending = result.isPending;
            this.isSuccess = result.isSuccess;
            this.isError = result.isError;
            this.errorMessage = result.error;

            if (this.isSuccess) {
              this.$store.cartPanel.updateCartHTML(result.data);
              this.$store.cartPanel.openCart();
            }
          },
        });
        this.addToCartMutation = addToCartMutation;
      },
      addToCart: async function () {
        const id = this.selectedVariant.id;
        const quantity = 1;

        let formData = {
          items: [
            {
              id,
              quantity,
            },
          ],
        };

        this.isPending = true;
        this.isError = false;
        this.errorMessage = '';
        this.isSuccess = false;
        const result = await this.$store.cart.addToCartMutation.mutate(formData, {
          onSuccess: async (data) => {
            await window.queryClient.invalidateQueries({ queryKey: ['cart'] });
            this.isSuccess = true;
            this.$store.cart.openCartPanel();
          },
          onError: (error) => {
            this.isError = true;
            this.errorMessage = error.message;
          },
          onSettled: () => {
            this.isPending = false;
          },
        });
      },
      onOpenQuickShop: function () {
        if (!this.available) {
          this.$store.outOfStock.setData({
            selectedVariant: this.selectedVariant,
            selectedOptions: this.selectedOptions,
            title: this.title,
            featuredImage: this.featuredImage,
            featuredImageWidth: this.featuredImageWidth,
            featuredImageHeight: this.featuredImageHeight,
            id: this.id,
            handle: this.handle,
            type: this.type,
            selectedVariantPrice: this.selectedVariantPrice,
          });
        } else if (this.has_only_default_variant) {
          this.addToCart();
        } else {
          this.openQuickShop();
        }
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-shop-panel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('quickShop', () => {
      return {
        isQuickShopOpen: false,
        openQuickShop() {
          this.isQuickShopOpen = true;
        },
        closeQuickShop() {
          this.isQuickShopOpen = false;
        },
        get isPanelOpen() {
          return this.isQuickShopOpen;
        },
        set isPanelOpen(value) {
          this.isQuickShopOpen = value;
        },
      };
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reviews-panel"] && !Shopify.designMode) return;
  try {
    window.ReviewsPanelComponent = function () {
    return {
      alreadyListeningToReviewsChanges: false,
      init: function () {
        this.$watch('isPanelOpen', (value) => {
          if (value) {
            // Trigger Judge.me's scroll-based lazy loader so it detects the
            // write-rev-link is now in the viewport and loads form.js, which
            // removes the inline display:none from the link and sets up the
            // modal click handler — making the button work on the first click.
            this.$nextTick(() => {
              let attempts = 0;
              const maxAttempts = 10;
              const interval = setInterval(() => {
                window.dispatchEvent(new Event('scroll'));
                attempts++;
                const writeRevLink = document.querySelector('.jdgm-write-rev-link');
                if ((writeRevLink && writeRevLink.style.display !== 'none') || attempts >= maxAttempts) {
                  clearInterval(interval);
                }
              }, 300);
            });
            this.hideEmptyCustomForms();
            this.moveDate();
            this.moveProductInfo();
          }
          if (value && !this.alreadyListeningToReviewsChanges) {
            this.listenToReviewsChanges(() => {
              this.hideEmptyCustomForms();
              this.moveDate();
              this.moveProductInfo();
            });
            this.alreadyListeningToReviewsChanges = true;
          }
        });

        const url = new URL(window.location.href);
        if (url.searchParams.has('write-a-review')) {
          url.searchParams.delete('write-a-review');
          history.replaceState(null, '', url.toString());
          this.isPanelOpen = true;
        }
      },
      get isPanelOpen() {
        return this.$store.reviewsPanel.isOpen;
      },
      set isPanelOpen(value) {
        this.$store.reviewsPanel.isOpen = value;
      },
      hideEmptyCustomForms: function () {
        const customForms = document.querySelectorAll('.jdgm-rev__custom-form');
        if (customForms.length > 0) {
          customForms.forEach((form) => {
            if (form.dataset.customFormMoved) return;
            const textContent = form.textContent.trim();
            if (textContent.length === 0) {
              form.classList.add('hidden');

              const hasPics = form.parentElement.querySelector('.jdgm-rev__pics');
              if (!hasPics) {
                const body = form.parentElement.querySelector('.jdgm-rev__body');
                if (body) {
                  body.classList.add('!pb-0', '!border-b-0');
                }
              }

              form.dataset.customFormMoved = 'true';
            }
          });
        }
      },
      listenToReviewsChanges: function (callback) {
        const target = document.querySelector('.jdgm-rev-widg__body');

        if (target) {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((m) => {
              if (m.type === 'childList') {
                callback();
              }
            });
          });

          observer.observe(target, {
            childList: true,
            subtree: false,
          });
        }
      },
      moveDate: function () {
        const reviewContainers = document.querySelectorAll('.jdgm-rev');
        reviewContainers.forEach((container) => {
          if (container.dataset.dateMoved) return;
          const date = container.querySelector('.jdgm-rev__timestamp');
          const title = container.querySelector('.jdgm-rev__title');
          const body = container.querySelector('.jdgm-rev__body');

          function formatDate(input) {
            const [m, d, y] = input.split('/');
            return `${d.padStart(2, '0')}.${m.padStart(2, '0')}.${y}`;
          }

          if (date && title && body) {
            date.textContent = formatDate(date.textContent);
            title.before(date);
            container.dataset.dateMoved = 'true';
          } else if (date && body) {
            date.textContent = formatDate(date.textContent);
            body.before(date);
            container.dataset.dateMoved = 'true';
          }
        });
      },
      moveProductInfo: function () {
        const reviewContainers = document.querySelectorAll('.jdgm-rev');
        reviewContainers.forEach((container) => {
          if (container.dataset.productInfoMoved) return;
          const productInfo = container.querySelector('.jdgm-rev__prod-variant-wrapper');
          const authorWrapper = container.querySelector('.jdgm-rev__author-wrapper');
          if (productInfo && authorWrapper) {
            const container = document.createElement('div');

            const title = document.createElement('div');
            title.textContent = 'Product Info';
            title.classList.add('!h4', '!mb-5');
            container.appendChild(title);

            container.classList.add('!w-1/2', '!pl-3.75');
            container.appendChild(productInfo);
            authorWrapper.after(container);

            container.dataset.productInfoMoved = 'true';
          }
        });
      },
    };
  };

  document.addEventListener('alpine:init', () => {
    Alpine.store('reviewsPanel', {
      isOpen: false,
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rich-text-accordion"] && !Shopify.designMode) return;
  try {
    window.RichTextAccordionComponent = function () {
    return {
      active: false,
      childrenHeight: `0px`,
      init: function () {},
      onClick: function () {
        const childrenHeight = this.$refs.children.offsetHeight;
        this.childrenHeight = childrenHeight + 'px';
        this.active = !this.active;
      },
      get arrowDirection() {
        return this.active ? 'down' : 'right';
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rich-text-with-products-snippet"] && !Shopify.designMode) return;
  try {
    window.StoryTextProductsSwiper = function () {
    return {
      init() {
        new Swiper(this.$refs.swiper, {
          slidesPerView: 2.1,
          spaceBetween: 12,
          mousewheel: {
            forceToAxis: true,
          },
        });
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["row-filter"] && !Shopify.designMode) return;
  try {
    window.RowFilterComponent = function () {
    return {
      rowFilterSwiper: null,
      init: function () {
        this.rowFilterSwiper = new Swiper(this.$refs.activityTags, {
          slidesPerView: 'auto',
          spaceBetween: 9,
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
        });

        this.$watch(
          'filters',
          () => {
            this.updateSwiper();
          },
          { deep: true }
        );
      },
      updateSwiper() {
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.rowFilterSwiper?.update();
          });
        });
      },
      onRowFilterClick(filterLabel, value) {
        this.isFilteredProductGridOpen = true;
        this.onFilterChange(filterLabel, value);

        if (!this.hasAnyFilterActive() && !this.isFiltersOpen) {
          this.isFilteredProductGridOpen = false;
        }
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["selectors"] && !Shopify.designMode) return;
  try {
    window.SelectorsComponent = function () {
    return {
      clickedCountry: null,
      clickedLocale: null,
      init: function () {
        const currencyList = this.$refs.currencyList;
        const languageList = this.$refs.languageList;
        const currencyListContainer = this.$refs.currencyListContainer;
        const languageListContainer = this.$refs.languageListContainer;

        const currencyListHeight = currencyList.offsetHeight;
        const languageListHeight = languageList.offsetHeight;

        currencyListContainer.style.setProperty('--height', `${currencyListHeight}px`);
        languageListContainer.style.setProperty('--height', `${languageListHeight}px`);
      },
      onButtonClick: function (type) {
        const container = this.$refs[`${type}Container`];
        container.dataset.open = container.dataset.open === 'true' ? 'false' : 'true';
      },
      onValueChange: async function (type, value) {
        const form = this.$refs.selectors.querySelector('form');
        const input = form.querySelector(`input[name="${type}"]`);
        input.value = value;
        if (type === 'country_code') {
          this.clickedCountry = value;
        } else {
          this.clickedLocale = value;
        }
        form.submit();
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["settings-store"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    return Alpine.store('settings', {
      hasProductHero: false,
      personalizationProductId: null,
      hasRowFilter: false,
      distanceFromRowFilterTopToPageTop: 0,
      rowFilterStickyStarted: false,
      // body scroll lock
      bodyScrollLockCount: 0,
      bodyPaddingRight: 0,
      enableBodyScrollLock: function () {
        if (this.bodyScrollLockCount === 0) {
          // Calculate scrollbar width to prevent layout shift
          this.bodyPaddingRight = window.innerWidth - document.documentElement.clientWidth;
          document.body.style.paddingRight = `${this.bodyPaddingRight}px`;
          document.body.style.overflow = 'hidden';
        }
        this.bodyScrollLockCount++;
      },
      disableBodyScrollLock: function () {
        this.bodyScrollLockCount--;
        if (this.bodyScrollLockCount <= 0) {
          this.bodyScrollLockCount = 0;
          this.bodyPaddingRight = 0;
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
        }
      },
      init() {
        this.personalizationProductId = JSON.parse(
          document.getElementById('settings-data').textContent
        ).personalizationProductId;
      },
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-estimator"] && !Shopify.designMode) return;
  try {
    window.ShippingEstimatorComponent = function () {
    return {
      zip: '',
      country: '',
      province: '',
      estimationMutation: null,
      isPending: false,
      isSuccess: false,
      isError: false,
      errorMessage: '',
      init: function () {
        const estimationMutation = window.createMutation({
          mutationFn: () => {
            return this.$store.cartApi.generateShippingRates({
              country: this.country,
              province: this.province,
              zip: this.zip,
            });
          },
          subscribeFn: async (result) => {
            this.isPending = result.isPending;
            this.isError = result.isError;
            this.errorMessage = result.error;
            if (result.isSuccess) {
              if (result.data.shipping_rates.length > 0) {
                this.isSuccess = true;
                this.shippingRates = result.data.shipping_rates;
              } else {
                this.isError = true;
                this.errorMessage = 'No shipping rates found';
              }
            }
          },
        });
        this.estimationMutation = estimationMutation;
      },
      get provinces() {
        const provinces = [];
        if (this.country) {
          const optionElement = document.querySelector(`[data-country-select] option[value="${this.country}"]`);
          if (optionElement) {
            const provincesData = JSON.parse(optionElement.dataset.provinces);
            if (provincesData.length > 0) {
              provinces.push(...provincesData);
            }
          }
        }

        return provinces;
      },
      get provinceOptionsHtml() {
        return [['Province', ''], ...this.provinces]
          .map((province) => `<option value="${province[1]}">${province[0].replace('-', ' ')}</option>`)
          .join('');
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-panel"] && !Shopify.designMode) return;
  try {
    window.SizeGuidePanelComponent = function () {
    return {
      tableTabs: [],
      activeTabIndex: 0,
      tableSourceObserver: null,
      isSyncingSourceTabs: false,
      init() {
        this.observeSizeGuideTableSource();
      },
      destroy() {
        this.tableSourceObserver?.disconnect();
      },
      observeSizeGuideTableSource() {
        const sizeGuideTableSource = document.querySelector('.TablePress');
        if (!sizeGuideTableSource) {
          return;
        }

        this.observeTableSourceChanges(sizeGuideTableSource);
        void this.syncTableTabsFromSource(sizeGuideTableSource);
      },
      observeTableSourceChanges(sizeGuideTableSource) {
        this.tableSourceObserver?.disconnect();
        this.tableSourceObserver = new MutationObserver(() => {
          if (this.isSyncingSourceTabs) {
            return;
          }

          void this.syncTableTabsFromSource(sizeGuideTableSource);
        });
        this.tableSourceObserver.observe(sizeGuideTableSource, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class', 'style'],
        });
      },
      async syncTableTabsFromSource(sizeGuideTableSource) {
        if (!sizeGuideTableSource) {
          return;
        }

        if (this.isSyncingSourceTabs) {
          return;
        }

        this.isSyncingSourceTabs = true;
        this.tableSourceObserver?.disconnect();

        try {
          const tabButtons = Array.from(sizeGuideTableSource.querySelectorAll('.sizechart-tab-button')) ?? [];
          if (tabButtons.length === 0) {
            const tableData = this.extractTableData(sizeGuideTableSource);
            this.tableTabs = tableData ? [{ label: '', tableData }] : [];
            this.activeTabIndex = 0;
            return;
          }

          const previousActiveLabel = this.tableTabs[this.activeTabIndex]?.label ?? '';
          const sourceActiveTabIndex = Math.max(
            tabButtons.findIndex((button) => button.classList.contains('active')),
            0
          );
          const tableTabs = [];

          for (const [tabIndex, button] of tabButtons.entries()) {
            if (!button.classList.contains('active')) {
              button.click();
              await this.waitForSourceTableUpdate();
            }

            const tableData = this.extractTableData(sizeGuideTableSource);
            if (tableData) {
              tableTabs.push({
                label: button.textContent.trim() || `Tab ${tabIndex + 1}`,
                tableData,
              });
            }
          }

          const sourceActiveButton = tabButtons[sourceActiveTabIndex];
          if (sourceActiveButton && !sourceActiveButton.classList.contains('active')) {
            sourceActiveButton.click();
            await this.waitForSourceTableUpdate();
          }

          this.tableTabs = tableTabs;
          if (tableTabs.length === 0) {
            this.activeTabIndex = 0;
            return;
          }

          const preservedTabIndex = previousActiveLabel
            ? tableTabs.findIndex((tab) => tab.label === previousActiveLabel)
            : -1;
          this.activeTabIndex =
            preservedTabIndex >= 0 ? preservedTabIndex : Math.min(sourceActiveTabIndex, tableTabs.length - 1);
        } finally {
          this.isSyncingSourceTabs = false;
          this.observeTableSourceChanges(sizeGuideTableSource);
        }
      },
      async waitForSourceTableUpdate() {
        await new Promise((resolve) => {
          window.setTimeout(resolve, 50);
        });
      },
      extractTableData(sizeGuideTableSource) {
        if (!sizeGuideTableSource) {
          return null;
        }

        const tableElement = sizeGuideTableSource.querySelector('table');
        if (!tableElement) {
          return null;
        }

        const tableData = [];
        const headCells = Array.from(tableElement.querySelectorAll('thead tr th')) ?? [];
        if (headCells.length === 0) {
          return null;
        }

        tableData.push(headCells.map((cell) => cell.textContent.trim()));
        const bodyRows = Array.from(tableElement.querySelectorAll('tbody tr')) ?? [];
        for (const row of bodyRows) {
          const cells = Array.from(row.querySelectorAll('td'));
          tableData.push(cells.map((cell) => cell.textContent.trim()));
        }

        return this.normalizeTableData(tableData);
      },
      normalizeTableData(tableData) {
        if (!Array.isArray(tableData) || tableData.length === 0) {
          return null;
        }

        const columnCount = tableData.reduce((maxColumnCount, row) => {
          return Math.max(maxColumnCount, row.length);
        }, 0);

        if (columnCount === 0) {
          return null;
        }

        const populatedColumnIndexes = [];
        for (let columnIndex = 0; columnIndex < columnCount; columnIndex++) {
          const hasColumnContent = tableData.some((row) => (row[columnIndex] ?? '').trim() !== '');
          if (hasColumnContent) {
            populatedColumnIndexes.push(columnIndex);
          }
        }

        if (populatedColumnIndexes.length === 0) {
          return null;
        }

        const normalizedTableData = tableData.map((row) =>
          populatedColumnIndexes.map((columnIndex) => row[columnIndex] ?? '')
        );

        return normalizedTableData.filter((row, rowIndex) => {
          if (rowIndex === 0) {
            return true;
          }

          return row.some((cell) => cell.trim() !== '');
        });
      },
      setActiveTab(tabIndex) {
        if (tabIndex < 0 || tabIndex >= this.tableTabs.length) {
          return;
        }

        this.activeTabIndex = tabIndex;
      },
      get activeTableData() {
        return this.tableTabs[this.activeTabIndex]?.tableData ?? null;
      },
      get activeTableColumnCount() {
        return this.activeTableData?.[0]?.length ?? 0;
      },
      get activeTableStyle() {
        if (this.activeTableColumnCount === 0) {
          return 'width: 100%;';
        }

        return `width: max(100%, ${this.activeTableColumnCount * 7}rem);`;
      },
      get hasTableTabs() {
        return this.tableTabs.length > 1;
      },
      get isPanelOpen() {
        return this.$store.product.isSizeGuidePanelOpen;
      },
      set isPanelOpen(value) {
        this.$store.product.isSizeGuidePanelOpen = value;
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-locator-select"] && !Shopify.designMode) return;
  try {
    window.StoreLocatorSelectComponent = function () {
    return {
      open: false,
      toggle() {
        if (this.open) {
          return this.close();
        }

        this.$refs.button.focus();

        this.open = true;
      },
      close(focusAfter) {
        if (!this.open) return;

        this.open = false;

        focusAfter && focusAfter.focus();
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-player"] && !Shopify.designMode) return;
  try {
    window.VideoPlayerComponent = function (useYoutube = false, controls_type) {
    return {
      isPlaying: false,
      videoElement: null,
      youtubeVideoPlayer: null,
      init() {
        if (useYoutube) {
          this.initYoutubeVideo();
        } else {
          this.initVideo();
        }
      },
      playVideo() {
        if (useYoutube && this.youtubeVideoPlayer) {
          this.youtubeVideoPlayer.playVideo();
          this.isPlaying = true;
          return;
        } else if (this.videoElement) {
          this.isPlaying = true;
          this.videoElement.play();
          if (controls_type === 'show_when_playing') {
            this.videoElement.controls = true;
          }
        }
      },
      initVideo() {
        this.videoElement = this.$root.querySelector('video');

        if (!this.videoElement) {
          return;
        }

        this.videoElement.addEventListener('play', () => {
          this.isPlaying = true;
          if (controls_type === 'show_when_playing') {
            this.videoElement.controls = true;
          }
        });
        this.videoElement.addEventListener('pause', () => {
          this.isPlaying = false;
        });
        this.videoElement.addEventListener('ended', () => {
          this.isPlaying = false;
        });
      },
      async initYoutubeVideo() {
        await customElements.whenDefined('lite-youtube');
        const el = this.$refs.youtubeVideo;
        if (!el || typeof el.getYTPlayer !== 'function') {
          return;
        }
        this.youtubeVideoPlayer = await el.getYTPlayer();
        this.youtubeVideoPlayer.addEventListener('onStateChange', (e) => {
          this.isPlaying = e.data === 1;
        });
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-page"] && !Shopify.designMode) return;
  try {
    window.WishlistPageComponent = function () {
    return {
      isEmpty: false,
    };
  };

  window.WishlistPageEmptyMessageIndicatorComponent = function () {
    return {
      init: function () {
        this.isEmpty = true;
      },
    };
  };

  window.WishlistProductCardComponent = function () {
    return {
      productHTML: null,
      isPending: false,
      isSuccess: false,
      init: function () {
        this.isEmpty = false;
        const handle = this.$root.dataset.wishlistProductHandle;
        const removeButton = this.$root.querySelector('remove-button');
        removeButton.style.display = 'none';

        window.query({
          key: ['product', handle],
          fn: () => this.getProduct(handle),
          subscribeFn: (result) => {
            this.isPending = result.isPending;
            this.isSuccess = result.isSuccess;
            if (result.isSuccess) {
              const html = new DOMParser().parseFromString(result.data['wishlist-product-card'], 'text/html');
              this.productHTML = html.querySelector('#wishlist-product-card').innerHTML;

              this.$nextTick(() => {
                const removeButton = this.$root.querySelector('remove-button');
                removeButton.removeAttribute('style');
                const removeButtonContainers = Array.from(
                  this.$root.querySelectorAll('[data-wishlist-product-remove-button-container]')
                );
                removeButtonContainers.forEach((container) => {
                  const clonedRemoveButton = removeButton.cloneNode(true);
                  clonedRemoveButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  });
                  container.appendChild(clonedRemoveButton);
                });
                removeButton.remove();
              });
            }
          },
        });
      },
      getProduct: function (handle) {
        return fetch(`${window.Shopify.routes.root}products/${handle}?sections=wishlist-product-card`).then(
          (response) => {
            return response.json();
          }
        );
      },
    };
  };
  } catch(e) { console.error(e); }
})();

})();
